const STAKEBASEURL = "https://stackbackend.decentrawood.com";

export const claimRewards = async (data) => {
    try {
        const resp = await fetch(`${STAKEBASEURL}/api/v1/rewards`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return resp.json();
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getRewardClaimHistory = async (user_address, type) => {
    try {
        const resp = await fetch(`${STAKEBASEURL}/api/v1/rewards?user_address=${user_address}&type=${type}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        return resp.json();
    } catch (error) {
        console.log(error);
        throw error;
    }
}